export const SELECTED_CANCER_TYPES_ANALYTICS_KEY = 'page_cancertypes';
export const SELECTED_CANCER_TYPES_COUNT_ANALYTICS_KEY = 'page_cancertypes_count';
export const CHATBOT_USER_OPEN_KEY = 'chatbot_open';
export const DO_ADDITIONAL_GTM_DATALAYER_PUSH = true;